module.exports = __webpack_public_path__ + "static/media/23.9d89fc93.png";